import { SET_APPLICATION_STATUS } from './actionTypes';

export const setApplicationStatus = (status, error) => ({
    type: SET_APPLICATION_STATUS,
    payload: { status },
    error,
});
